import { LinearProgress } from '@mui/material';
import { FunctionComponent, useContext, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import { ClockContext } from '@/hocs/with-clock';

const useStyles = makeStyles()(() => ({
  indeterminate: {
    opacity: 0.15,
  },
}));

export interface Properties {
  reset: boolean;
}

const ProgressBar: FunctionComponent<Properties> = ({ reset }) => {
  const [baseTime, setBaseTime] = useState(Date.now());
  const [terminationTime, setTerminationTime] = useState(0);
  const { currentTime, start } = useContext(ClockContext);

  const { classes, cx } = useStyles();

  useEffect(start, []);

  const now = currentTime.getTime();

  useEffect(() => {
    if (reset) {
      if (baseTime) {
        setTerminationTime(now + (now - baseTime));
      }

      setBaseTime(now);
    }
  }, [reset]);

  const determinate = !!terminationTime;
  const progress = !determinate ? 0 : (terminationTime - now) / (terminationTime - baseTime);

  return (
    <LinearProgress
      className={cx({ [classes.indeterminate]: !determinate })}
      variant={determinate ? 'determinate' : 'indeterminate'}
      value={Math.max(Math.min(Math.floor((1 - progress) * 100), 100), 0)}
    />
  );
};

export default ProgressBar;
